export const isApplyDisabled = (selectedRows: unknown[] | undefined) =>
  (selectedRows?.length ?? 0) === 0
